import { GetterTree } from 'vuex';

import { RootState } from '@/store';
import { State } from './state';
import { PagerItem } from "@/types";

export type Getters = {
    getPager(state: State): PagerItem[] | [];
    getNextPageUrl(state: State): string | null;
}

export const getters: GetterTree<State, RootState> & Getters = {
    getPager: state => state.pager,
    getNextPageUrl: state => state.nextPageUrl,
};
